import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, TextField, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const KeywordAccordion = ({ keyword, setKeyword, keywordsList, setKeywordsList }) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: '#f5f5f5', // Very light gray color
        }}
      >
        {/* Navy Blue Circle with Item Count */}
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            backgroundColor: '#00274D', // Navy blue color
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 1, // Margin right to add spacing between the badge and the text
          }}
        >
          <Typography variant="body2" sx={{ color: 'white' }}>
            {keywordsList.length}
          </Typography>
        </Box>

        <Typography>Keyword</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ mb: 2 }}>
          {/* Keyword Input Field and Buttons */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <TextField
              fullWidth
              variant="outlined"
              label="Enter Keyword"
              value={keyword} // Connect input value to state
              onChange={(e) => setKeyword(e.target.value)} // Update state on input change
            />
            <IconButton onClick={() => setKeyword('')} sx={{ ml: 1 }}>
              <ClearIcon />
            </IconButton>
          </Box>
          
          {/* Add Button Below the Input Field */}
          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              if (keyword.trim()) { // Check if the input is not empty or just spaces
                setKeywordsList([...keywordsList, keyword.trim()]); // Add to keywords list
                setKeyword(''); // Clear input field after adding
              }
            }}
            sx={{ mb: 2 }}
          >
            Add
          </Button>

          {/* Display the List of Added Keywords */}
          {keywordsList.map((item, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Typography variant="body1" sx={{ flexGrow: 1 }}>
                {item}
              </Typography>
              <IconButton onClick={() => setKeywordsList(keywordsList.filter((_, i) => i !== index))}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default KeywordAccordion;